import React, { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import Box from '@mui/material/Box';

import { EntityHistoryEntryIcon_entry$key } from '__generated__/EntityHistoryEntryIcon_entry.graphql';

type Props = {
  entry: EntityHistoryEntryIcon_entry$key;
};

const icons = {
  INFO: <InfoIcon color="info" fontSize="small" sx={{ mr: 1 }} />,
  WARNING: <WarningIcon color="warning" fontSize="small" sx={{ mr: 1 }} />,
  ERROR: <ErrorIcon color="error" fontSize="small" sx={{ mr: 1 }} />,
};

const EntityHistoryEntryIcon: FC<Props> = ({ entry }) => {
  const { severity } = useFragment(
    graphql`
      fragment EntityHistoryEntryIcon_entry on LogEntry {
        severity
      }
    `,
    entry
  );

  return <Box component="span">{icons[severity]}</Box>;
};

export default EntityHistoryEntryIcon;
